export default __webpack_public_path__ + "static/media/catbears_angry.ce52f5f4.png";